import { useEffect, useRef, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Loads a member's saved reflection answers for a module and autosaves edits (800ms debounce).
export const useWorkbookAnswers = (moduleId, enabled) => {
  const [answers, setAnswers] = useState({});
  const [saveState, setSaveState] = useState("idle"); // idle | saving | saved
  const saveTimer = useRef(null);

  useEffect(() => {
    setAnswers({});
    setSaveState("idle");
    if (saveTimer.current) clearTimeout(saveTimer.current);
    if (!enabled) return undefined;
    let alive = true;
    axios.get(`${API}/workbook/${moduleId}`).then((r) => {
      if (alive) setAnswers(r.data?.answers || {});
    }).catch(() => {});
    return () => { alive = false; };
  }, [moduleId, enabled]);

  const onAnswerChange = (i, val) => {
    setAnswers((prev) => {
      const next = { ...prev, [i]: val };
      setSaveState("saving");
      if (saveTimer.current) clearTimeout(saveTimer.current);
      saveTimer.current = setTimeout(async () => {
        try {
          await axios.post(`${API}/workbook/${moduleId}`, { answers: next });
          setSaveState("saved");
        } catch {
          setSaveState("idle");
        }
      }, 800);
      return next;
    });
  };

  return { answers, saveState, onAnswerChange };
};
